/** DEC-154's dedicated inbound port. OPBridge only SUBSCRIBES to it (never
 *  sends) — no echo loop. Windows-only today (loopMIDI); Mac CoreMIDI
 *  virtual-input is a deferred Mac-session gap, same as the `"OPButtons"`
 *  output port. HYPHEN, not a space — OPBridge learned (S113) that Ableton
 *  filters MIDI port names containing spaces/parens, and the operator
 *  points an Ableton mirror track's input at this port. */
export const MIDI_TRIGGER_PORT = 'OPButtons-Control';
